import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Question } from '@app/shared/models/question';
import { Guid } from '@app/shared/models/guid';

@Component({
  selector: 'db-responsibilities-list-dialog',
  templateUrl: './responsibilities-list-dialog.component.html',
  styleUrls: ['./responsibilities-list-dialog.component.scss']
})
export class ResponsibilitiesListDialogComponent implements OnInit {
  dialogRef: MatDialogRef<ResponsibilitiesListDialogComponent>;
  field: Question;
  form: FormArray;
  model: any;

  constructor(private _fb: FormBuilder,
              private _dialogRef: MatDialogRef<ResponsibilitiesListDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: { model: any, field: Question }) { }

  ngOnInit(): void {
    this.dialogRef = this._dialogRef;
    this.model = this.data.model;
    this.field = this.data.field;

    this.form = this.createForm();
  }

  saveQuestion(): void {
    this.model[this.field.key] = {
      responsibleRoles: this.form.value
    }
    
    this.dialogRef.close(this.model);
  }

  addEntry(): void {
    this.form.push(this.createNewField());
  }

  deleteEntry(index: number): void {
    this.form.removeAt(index);

    if (!this.form.length) {
      this.form.push(this.createNewField());
    }
  }

  private createForm(): FormArray {
    const form: FormArray = this._fb.array([]) as FormArray;

    const field = this.model[this.field.key];

    if (field) {
      field.responsibleRoles.forEach((r: any) => {
        form.push(this.createNewField(r));
      });
    }
    else {
      form.push(this.createNewField());
    }

    return form;
  }

  private createNewField(role?: any): FormGroup {
    return this._fb.group({
      id:  role ? role.id : Guid.newGuid(),
      name: [role ? role.name : null, [Validators.required]],
      abbreviation: [role ? role.abbreviation : null, [Validators.required]],
    });
  }
}
